<script lang="ts" setup>
    const { side } = defineProps<{
        side?: boolean
    }>()
    const el = ref<HTMLElement|null>(null
    )
    const p = ref('')
    const dense = inject<boolean>('dense', false)

    if (side)  {
        onMounted(() => {

            const item = el.value?.parentNode

            let sibling = el.value?.parentNode?.firstChild
            let i = 0;
            let current: number|null
            let main: number|null

            while(sibling) {
                if (sibling.nodeType === 1) {
                    if (sibling === el.value)
                        current = i
                    if (sibling.classList.contains('main'))
                        main = i
                    i++
                }
                sibling = sibling.nextSibling
                
            }
        
            p.value = main < current
                ? 'items-end '
                : 'items-start '
            p.value += main < current
                ? dense ? 'pl-2' : 'pl-3'
                : + dense ? 'pr-2' : 'pr-3'
        })
    }
    
</script>

<template>
    <div class="item-section" :class="[side ? 'side' : 'main', p]" ref="el">
        <slot />
    </div>
</template>

<style scoped>
.item-section {
    @apply flex flex-wrap flex-col max-w-full text-start h-full;
}
.item-section.main {
    flex: 10000 1 0%;
}
.item-section.side {
    min-width: 52px;
}
</style>